import { Dialog } from "@radix-ui/react-dialog";
import { DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@component/dialog";
import { Button } from "@component/button";
import { MailCheckIcon } from "lucide-react";

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    employeeCount: number;
    personaName: string;
    submitting?: boolean;
}

export function SendInvitesConfirmDialog({
    open,
    onClose,
    onConfirm,
    employeeCount,
    personaName,
    submitting,
}: Props) {
    return (
        <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
            <DialogContent className="sm:max-w-md p-6" closeButtonClassName="top-4 right-4">
                <DialogHeader className="flex flex-row items-center gap-3 text-left">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center">
                        <MailCheckIcon className="h-5 w-5 text-blue-600" />
                    </div>
                    <DialogTitle className="text-lg font-semibold">
                        Send invites?
                    </DialogTitle>
                </DialogHeader>

                <DialogDescription className="text-sm text-gray-700">
                    This will email {employeeCount} employee{employeeCount === 1 ? "" : "s"} a
                    tokenised link to roleplay with the {personaName} persona.
                </DialogDescription>

                <div className="space-y-2 border border-gray-200 rounded-md p-3 text-sm">
                    <div className="flex justify-between">
                        <span className="text-gray-500">Recipients</span>
                        <span className="font-medium text-gray-900">{employeeCount}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500">Persona</span>
                        <span className="font-medium text-gray-900">{personaName}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500">Token validity</span>
                        <span className="font-medium text-gray-900">7 days</span>
                    </div>
                </div>

                <div className="flex justify-end gap-2 pt-2">
                    <Button variant="outline" onClick={onClose} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} disabled={submitting}>
                        {submitting ? "Sending..." : "Confirm & send"}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
